export const ar = {
  msg:
    {
      'username': 'الاسم المستخدم ',
      'password': 'كلمة المرور',
      'login': 'تسجيل الدخول ',
      'username_not_found': 'من فضلك،أدخل اسم المستخدم الخاص بك',
      'password_not_found': 'من فضلك، أدخل كلمة المرور الخاصة بك',
      'error': 'اسم المستخدم أو كلمة السر غير صالح',
      'changeLanguage': '',
      'lang-en': 'English',
      'lang-ms': 'Bahasa Melayu',
      'submit_button_text': 'Submit',
      'enter': 'دخول',
      'en': 'English',
      'ms': 'Bahasa Melayu',
      'zh': 'Chinese',
      'ta': 'Tamil',
      'km': 'Khmer',
      'th': 'Thai',
      'id': 'Bahasa Indonesia',
      'ar': 'Arabic',
      'blank_username_field': 'من فضلك،أدخل اسم المستخدم الخاص بك.',
      'blank_password_field': 'من فضلك، أدخل كلمة المرور الخاصة بك.',
      'invalid_credentials': 'اسم المستخدم أو كلمة السر غير صالح.',
      'copyright': 'Global Psytech مدعما من'
    }
}
